import { render, staticRenderFns } from "./StoreOwnerPhoneForm.vue?vue&type=template&id=1ff01d8a&"
import script from "./StoreOwnerPhoneForm.vue?vue&type=script&lang=js&"
export * from "./StoreOwnerPhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports